import { PrizeResults, SpinResults } from "./api/IGameAPI";

export class GameVars {

    public static scaleY: number;
    public static aspectRatio: number;
    public static currentScene: Phaser.Scene;
    public static intitialised: boolean;
    public static paused: boolean;
    public static i: number;
    public static selectedPresent: number;
    public static spinsCounter: number;


    public static gameInfo: any;
    public static prizeResults: PrizeResults;
    public static spinResponse: SpinResults;
  
    public static formatNumber(value: number): string {

        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
}
